import { CommonDialog } from "@/components/utils/CommonDialog";
import { InputBase, SxProps } from "@mui/material";
import { useState } from "react";

const ConversationTextFieldSx: SxProps = {
  fontSize: "1rem",
  "& .MuiInputBase-input": {
    borderBottomWidth: "1px",
    borderBottomColor: "black",
    borderBottomStyle: "solid",
    padding: 0,
  },
};

interface Props {
  conversationTitle: string;
  showRenameModal: boolean;
  handleOnClose: () => void;
  handleRenameTitle: (newTitle: string) => void;
}

export const RenameConversationModal = ({ conversationTitle, showRenameModal, handleOnClose, handleRenameTitle }: Props) => {
  const [title, setTitle] = useState<string>(conversationTitle);

  return (
    <>
      <CommonDialog
        showModal={showRenameModal}
        handleButtonClick={() => handleRenameTitle(title)}
        rightButtonText={"Confirm"}
        leftButtonText={"Cancel"}
        title={"Rename Conversation"}
        handleOnClose={handleOnClose}
      >
        <InputBase sx={ConversationTextFieldSx} autoFocus value={title} onChange={(event) => setTitle(event.target.value)} />
      </CommonDialog>
    </>
  );
};
